export default __webpack_public_path__ + "7_download_mobile_pl.png";